import getColumnSearch from './getColumnSearch';
import getColumnMoney from './getColumnMoney';
import getColumnDate from './getColumnDate';
import getColumnStaff from './getColumnStaff';
import getColumnDepartment from './getColumnDepartment';
import renderCell from './Cells';
var FilterEnum;
(function (FilterEnum) {
    FilterEnum["MONEY"] = "money";
    FilterEnum["NUMBER"] = "number";
    FilterEnum["DATE"] = "date";
    FilterEnum["SHORT_DATE"] = "shortdate";
    FilterEnum["DATE_RANGE"] = "dateRange";
    FilterEnum["List"] = "list";
    FilterEnum["STAFF"] = "organization:staff";
    FilterEnum["DEPARTMENT"] = "organization:department";
})(FilterEnum || (FilterEnum = {}));
var FilterColumn = function (props) {
    var _a;
    var key = props.key, filterType = props.filterType, filterDataSource = props.filterDataSource;
    var cellRender = renderCell(props);
    if (filterType === FilterEnum.MONEY || filterType === FilterEnum.NUMBER) {
        return getColumnMoney(cellRender);
    }
    else if (filterType === FilterEnum.DATE ||
        filterType === FilterEnum.SHORT_DATE ||
        filterType === FilterEnum.DATE_RANGE) {
        return getColumnDate(cellRender);
    }
    else if (filterType === FilterEnum.List) {
        var filters = (_a = filterDataSource === null || filterDataSource === void 0 ? void 0 : filterDataSource.map) === null || _a === void 0 ? void 0 : _a.call(filterDataSource, function (item) {
            item.text = item === null || item === void 0 ? void 0 : item.label;
            return item;
        });
        return { filters: filters };
    }
    else if (filterType === FilterEnum.STAFF) {
        return getColumnStaff(cellRender);
    }
    else if (filterType === FilterEnum.DEPARTMENT) {
        return getColumnDepartment(cellRender);
    }
    else {
        return getColumnSearch(cellRender);
    }
};
export default FilterColumn;
